import {css} from 'styled-components';
import {darken, lighten} from 'polished';

/* Test styles are used for components with text, spans labels, buttons etc. */
const HtmlStyles = css`
  &, .ProseMirror {
    h1, h2, h3 {
      &:not(:first-child) {
        margin-top: ${props => props.theme.spacing(1)};
      }

      ~ ul, ~ ol {
        margin-top: ${props => props.theme.spacing(0)};
      }
    }

    > ul, > ol {
      margin-top: ${props => props.theme.spacing(0)};
      margin-left: ${props => props.theme.spacing(2)};
      
      &[data-type="taskList"] {
        margin-top: ${props => props.theme.spacing(0)};
        margin-left: ${props => props.theme.spacing(0)};
        
        input {
          outline: none;
        }
      }

      > li {
        margin-bottom: ${props => props.theme.spacing(0)};
      }

      ul, ol {
        margin-top: ${props => props.theme.spacing(0)};
        margin-left: ${props => props.theme.spacing(1.75)};
        margin-bottom: ${props => props.theme.spacing(0)};
      }
    }

    a {
      outline: none;
      text-decoration: none;
      cursor: pointer;
      color: ${props => props.theme.property('palette.primary.main')};
      max-width: fit-content;
      line-break: anywhere;

      &:focus {
        text-decoration: underline !important;
      }
    }

    img {
      height: auto;
      max-width: 100%;
      object-fit: contain;
    }

    table {
      font-size: 90%;
      border-spacing: 0;
      margin-top: ${props => props.theme.spacing(0)};
      border-color: ${props => darken(0.2, props.theme.property('palette.divider'))};
      border: 1px solid ${props => darken(0.2, props.theme.property('palette.divider'))};
      background-color: ${props => props.theme.property('palette.background.paper')};
      
      display: inline-block;
      overflow: auto;
      table-layout: auto !important;
      width: 100% !important;
      min-width: unset !important;
      max-width: 100% !important;

      colgroup {
        col {
          min-width: unset !important;
        }
      }

      thead, tbody {
        tr {
          th {
            padding: ${props => props.theme.spacing(1)};
            background-color: ${props => lighten(0.1, props.theme.property('palette.divider'))};

            text-align: left;

            border: none;
            border-color: ${props => props.theme.property('palette.divider')};
            border-bottom: 1px solid ${props => darken(0.2, props.theme.property('palette.divider'))};
            
            &:not(:first-child) {
              border-left: 1px solid ${props => darken(0.2, props.theme.property('palette.divider'))};
            }
          }
        }
      }

      tbody {
        tr {
          td {
            padding: ${props => props.theme.spacing(1)};
            text-align: left;

            border: none;
            border-color: ${props => props.theme.property('palette.divider')};
            border-bottom: 1px solid ${props => props.theme.property('palette.divider')};
            
            &:not(:first-child) {
              border-left: 1px solid ${props => props.theme.property('palette.divider')};
            }
          }

          &:last-child {
            td {
              border-bottom: unset;
            }
          }
        }
      }
    }
  }
  
  // overrides
  ${props => props.theme.property('mixins.HtmlStyles')}
  ${props => props.theme.convert2Css(props.theme.property('components.HtmlStyles.styleOverrides.root'))}
`

export default HtmlStyles;
